const SurveyInaccessibleType = {
  CAMPAIGN_CLOSED: 0,
  ALREADY_ANSWERED: 1,
  UNSUBSCRIBED: 2,
  UNKNOWN: 3,
  RESPONSE_LIMIT_REACHED: 4
} as const;

export type InaccessibleTypeValue =
  (typeof SurveyInaccessibleType)[keyof typeof SurveyInaccessibleType];

export default SurveyInaccessibleType;
